// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Row, Col } from '../../components/Elemental'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'

// CSS
import './styles.scss'

// Components/Containers
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import LogoFull from '../../components/LogoFull'
import Warning from '../Warning'

// Validate
import { required, email } from '../../constants/validate'

// Actions
import { forgetPw } from './actions'

class ForgetPwPage extends Component {
  handleFormSubmit = (reduxFormData) => {
    const { forgetPw } = this.props

    return forgetPw(reduxFormData)
  }

  render() {
    const { err, success, localLoading, handleSubmit } = this.props

    return (
      <div className="forget-pw-page">
        <LogoFull width={220} gutterBottom={10} />
        <Form autoComplete="off" onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Row>
            <Col>
              <Field
                component={Input}
                type="email"
                name="email"
                placeholder="Email"
                gutter={15}
                validate={[required, email]} />
            </Col>
          </Row>
          <Warning error={err} success={success} gutter={40} align="center" />
          <Button type="submit" localLoading={localLoading} gutter={15}>Redefinir Senha</Button>
        </Form>
        <h3 className="forget-pw-page__redirect">
          <NavLink className="forget-pw-page__link" to="/login">Voltar para o login</NavLink>
        </h3>
      </div>
    )
  }
}

ForgetPwPage = reduxForm({
  form: 'forgetPw',
})(ForgetPwPage)

ForgetPwPage = connect(state => {
  return {
    localLoading: state.app.localLoading,
    err: state.app.err,
    success: state.app.success,
  }
}, { forgetPw })(ForgetPwPage)

export default ForgetPwPage
